import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter, ElementRef, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-filterSearchMultiple',
  templateUrl: './filterSearchMultiple.component.html',
  styleUrls: ['./filterSearchMultiple.component.scss']
})
export class FilterSearchMultipleComponent implements OnInit, OnChanges {
  @Input() data: { placeholder: string, filterOptions: any[], optionValue: string[], circularTag: boolean };
  @Output() messageEvent = new EventEmitter<any>();
  placeholder: any;
  myControl = new FormControl();
  searchControl = new FormControl('');
  filteredOptions: Observable<any[]>;
  options: any[] = [];
  optionValue: string[] = [];
  circularTag: boolean = false;
  @Input() resetSearch!: boolean; 
  @Input() disabled: boolean = false;
  
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data) {
      this.options = Object.assign([], this.data.filterOptions);
      this.optionValue = this.data.optionValue || [];
      this.placeholder = this.data.placeholder;
      this.circularTag = this.data.circularTag;
      this.myControl.setValue(this.optionValue, { emitEvent: false });
    }

    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value || ''))
      );

    if (changes['resetSearch'] && changes['resetSearch'].currentValue) {
      this.clearSelection();
    }

    if (this.disabled) {
      this.myControl.disable();
    } else {
      this.myControl.enable();
    }
  }

  _filter(value: any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
  
  onSelectionChange() {
    this.messageEvent.emit(this.myControl.value);
  }
  
  clearSelection() {
    this.myControl.setValue([]);
    this.messageEvent.emit([]);
  }
}
